import Axios from "axios";
import { authorizationHeader } from "./apiUtils";
import { FilterOption } from "../models/misc";

const baseRoute = "/api/filters";

export async function getFilterOptions(filterId: number): Promise<FilterOption[]> {
  const resp = await Axios.get<FilterOption[]>(
    `${baseRoute}/${filterId}/options`,
    { headers: authorizationHeader() }
  );
  return resp.data;
}

export async function getFilterOption(filterId: number, optionId: number): Promise<FilterOption> {
  const resp = await Axios.get<FilterOption>(
    `${baseRoute}/${filterId}/options/${optionId}`,
    { headers: authorizationHeader() }
  );
  return resp.data;
}

export async function createOption(option: Partial<FilterOption>): Promise<FilterOption> {
  const resp = await Axios.post<FilterOption>(
    `${baseRoute}/${option.filterId}/options`,
    option,
    { headers: authorizationHeader() }
  );
  return resp.data;
}

export async function updateOption(option: FilterOption): Promise<void> {
  await Axios.put(
    `${baseRoute}/${option.filterId}/options/${option.optionId}`,
    option,
    { headers: authorizationHeader() }
  );
}

export async function deleteOption(filterId: number, optionId: number): Promise<void> {
  await Axios.delete(
    `${baseRoute}/${filterId}/options/${optionId}`,
    { headers: authorizationHeader() }
  );
}
